import type { Breakpoints } from '../types/mobile-layout';

/**
 * Standard breakpoint values following Tailwind CSS default breakpoints
 */
export const breakpoints: Breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
};

/**
 * Mobile breakpoint - devices with width ≤ 768px are considered mobile
 */
export const MOBILE_BREAKPOINT = breakpoints.md;

/**
 * Get the current breakpoint based on viewport width
 */
export function getBreakpoint(width: number): keyof Breakpoints | 'xs' {
  if (width < breakpoints.sm) return 'xs';
  if (width < breakpoints.md) return 'sm';
  if (width < breakpoints.lg) return 'md';
  if (width < breakpoints.xl) return 'lg';
  return 'xl';
}

/**
 * Check if viewport width is mobile size
 * Mobile: width < 768px (excludes 768 boundary)
 */
export function isMobileWidth(width: number): boolean {
  return width < MOBILE_BREAKPOINT;
}

/**
 * Check if viewport width is tablet size
 * Tablet: width >= 768px and width <= 1024px (inclusive boundaries)
 */
export function isTabletWidth(width: number): boolean {
  return width >= MOBILE_BREAKPOINT && width <= breakpoints.lg;
}

/**
 * Check if viewport width is desktop size
 * Desktop: width > 1024px (excludes 1024 boundary)
 */
export function isDesktopWidth(width: number): boolean {
  return width > breakpoints.lg;
}
